import Body from "./Body";
import Snout from "./Snout";
import Eyes from "./Eyes";
import Accessory from "./Accessory/Accessory";

const PreviewImage = {Body, Snout, Eyes, Accessory};
export default PreviewImage;
